<template>
  <v-toolbar
    class="user-toolbar"
    color="white"
    clipped-left
    app
  >
    <img
      class="logo"
      src="/static/images/base/new-docgo-logo.svg"
      width="100"
      @click="goToHomePage"
    />
    <v-spacer></v-spacer>
    <global-search-text-field v-show="showSearch" showSearch="showSearch"/>
    <v-layout justify-start class="pt-3 ml-2">
      <search-all-folders v-show="showGeneralSearch()"/>
    </v-layout>

    <v-spacer></v-spacer>
    <settings v-if="user.super_admin"></settings>
    <user-menu></user-menu>
    <!--    <user-notifications class="mx-2"></user-notifications>-->
  </v-toolbar>
</template>

<script>
  import SearchAllFolders from '@/components/base/SearchAllFolders';
  import UserNotifications from './UserNotifications';
  import UserMenu from './UserMenu';
  import Settings from './Settings';
  import GlobalSearchTextField from './GlobalSearchTextField';

  export default {
    name: 'user-toolbar',
    components: {
      GlobalSearchTextField,
      SearchAllFolders,
      UserMenu,
      UserNotifications,
      Settings,
    },
    data() {
      return {
        searchIsFocused: false,
      };
    },
    props: {
      showSearch: {
        default: true,
      },
    },
    methods: {
      expressionTest(item, value) {
        const expression = new RegExp(value, 'i');
        const propertyToSearch = 'name';
        return expression.test(item[propertyToSearch]);
      },
      // searchFolder(event) {
      //   const value = event.target.value;
      //   const itemsFound = filter(this.folders, item => (
      //     this.expressionTest(item.folder_type, value)
      //   ));
      //   this.$store.dispatch('setFoldersFound', itemsFound);
      // },
      goToHomePage() {
        window.location= '/';
        // this.$router.push('/');
      },
      showGeneralSearch() {
        var perm = this.user.permissions;
        if (perm) return perm.general_search;
        return false;
      }
    },
    computed: {
      folders() {
        return this.$store.getters.folders;
      },
      // showSearch() {
      //   return this.$router.currentRoute.name !== 'Profile';
      // },
      user() {
        return this.$store.getters.user;
      },
    },
  };
</script>

<style lang="scss">
.user-toolbar {
  .logo {
   cursor: pointer;
  }
  .search-field {
    align-self: flex-end;
    color: inherit;

    .v-input__slot {
      border-radius: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user-toolbar/UserToolbar.vue